// Helpers
import '@helpers/vhFix';
import '@helpers/ScrollLock';
// Plugins (external plugins/libs)
// import './plugins/inputmask/inputmask.js';
// import './plugins/aos/aos';
// import './plugins/glightbox/glightbox';
// import './plugins/inputmask/inputmask.js';
// import './plugins/countup/countup';
// import './plugins/tippy/tippy.js';
document.documentElement.classList.add('is-loaded');
// Index page
import './components/index/index';
// Components
import './components/validator/validator.js';
import './components/popup/popup';
import './components/collapse/collapse';
// import './components/tabs/tabs';
// import './components/dropdown/dropdown';
import './components/page/page';
import './components/nav/nav';
import './components/menu/menu';
import './components/home-slider/home-slider';
import './components/view-cursor/view-cursor';
import './components/lazy-preloader/lazy-preloader';
import './components/textarea/textarea';
import './components/photos-slider/photos-slider';
import './components/covers-carousel/covers-carousel';
import './components/project-view/project-view';
import './components/lightbox/lightbox';
import './components/combobox/combobox';
import './components/workflow-section/workflow-section';
import './components/design-section/design-section';
import './components/selected-works-section/selected-works-section';
